import { Component, Input, OnInit } from '@angular/core'
import { DateFormatService } from 'dmmp-services'

@Component({
  selector: 'dmmp-new-view',
  templateUrl: './new-view.component.html'
})
export class NewViewComponent implements OnInit {

  @Input() newInfo
  @Input() module

  constructor(private dateFormatService: DateFormatService) { }

  ngOnInit(): void {
    this.newInfo.promotion_date = this.dateFormatService.convertFromTimestampToDate(this.newInfo?.promotion_date)
  }

}
